import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { VehicleSpecsPage } from '@/features/vehicle-specs/vehicle-specs-page';

/**
 * The vehicle-model editor. Every endpoint requires `platform:manage` (GLOBAL admins): a model is
 * shared by every dealer on its VIN prefix. The feature itself has no dealer-specific imports, so
 * it can move to a shared package with the tyre-analytics portal; only this route is the dealer's.
 */
export const Route = createFileRoute('/_app/vehicle-specs')({
  staticData: { featureKey: 'vehicle-specs' },
  beforeLoad: ({ context, location }) =>
    requireFeature(context, location, {
      feature: 'vehicle-specs',
      permissions: ['platform:manage'],
    }),
  component: VehicleSpecsPage,
});
